import React from 'react';
import {
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from '@mui/material';
import PropTypes from 'prop-types';

import { ChannelBuckets } from '../../../utils/channelBuckets';
import { ChannelActions, channelActionConfig } from '../../../utils/channelActions';
import {
  StyledArchiveIcon,
  StyledUnarchiveIcon,
  StyledHideIcon,
  StyledShowIcon,
  StyledList,
} from './styles';

const ChannelActionPopover = React.forwardRef(({
  selectedBucket,
  handleAction,
}, ref) => {
  const actionIcon = {
    [ChannelActions.ARCHIVE]: <StyledArchiveIcon />,
    [ChannelActions.UNARCHIVE]: <StyledUnarchiveIcon />,
    [ChannelActions.HIDE]: <StyledHideIcon />,
    [ChannelActions.SHOW]: <StyledShowIcon />,
  };

  const renderListItem = (action) => (
    <ListItem disablePadding onClick={() => handleAction(action)}>
      <ListItemButton>
        <ListItemIcon>
          {actionIcon[action]}
        </ListItemIcon>
        <ListItemText primary={channelActionConfig[action].label} />
      </ListItemButton>
    </ListItem>
  );

  return (
    <StyledList ref={ref}>
      {
        selectedBucket === ChannelBuckets.ACTIVE
        && renderListItem(ChannelActions.ARCHIVE)
      }
      {
        selectedBucket === ChannelBuckets.ARCHIVED
        && renderListItem(ChannelActions.UNARCHIVE)
      }
      {
        (selectedBucket === ChannelBuckets.ACTIVE || selectedBucket === ChannelBuckets.ARCHIVED)
        && renderListItem(ChannelActions.HIDE)
      }
      {
        selectedBucket === ChannelBuckets.ALL
        && renderListItem(ChannelActions.SHOW)
      }
    </StyledList>
  );
});

ChannelActionPopover.propTypes = {
  selectedBucket: PropTypes.string.isRequired,
  handleAction: PropTypes.func.isRequired,
};

export default ChannelActionPopover;
